import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from './useGetCurrentProgramOntologyConfig'

export type DisplayOntologyFeature = {
  featureId: string
  data: {
    name: string
    color?: string
    description?: string
  }
}

export type DisplayOntology = {
  features: DisplayOntologyFeature[]
  subClassificationFeatures: DisplayOntologyFeature[]
}

const DISPLAY_ONTOLOGY_STALE_TIME = 5 * 60 * 1000

export function useGetDisplayOntology(programId?: string, engagementId?: string) {
  return useQuery({
    queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY, 'display', programId ?? '', engagementId ?? ''],
    queryFn: async () => {
      const { data } = await apiClient.get<DisplayOntology>(
        `/int/v3/programs/${programId}/display-ontology`,
        {
          params: engagementId ? { engagementId } : {},
        }
      )
      return data
    },
    enabled: Boolean(programId),
    staleTime: DISPLAY_ONTOLOGY_STALE_TIME,
    refetchOnWindowFocus: false,
  })
}
